import { FileTextOutlined, UserAddOutlined, SafetyCertificateOutlined } from '@ant-design/icons';

const icons = {
  FileTextOutlined,
  UserAddOutlined,
  SafetyCertificateOutlined
};

const payments = {
  id: 'payments',
  title: 'Payments & Access',
  type: 'group',
  children: [
    {
      id: 'payments-orders',
      title: 'Orders',
      type: 'item',
      url: '/payments/orders',
      icon: icons.FileTextOutlined
    },
    {
      id: 'payments-users-orders',
      title: 'Users',
      type: 'item',
      url: '/users',
      icon: icons.UserAddOutlined,
      breadcrumbs: false
    },
    {
      id: 'roles',
      title: 'Roles & Permissions',
      type: 'item',
      url: '/roles',
      icon: icons.SafetyCertificateOutlined,
      breadcrumbs: false
    }
  ]
};

export default payments;
